import { get } from "../GenericServices";

const ExportBpc = {
  exportBpc: () => {
    return get(`export-bpc`);
  },
  exportBpcInfo: () => {
    return get(`export-bpc/info`);
  },
  exportBpcFile: () => {
    return get(`export-bpc/file`, {}, "blob");
  },
};

export default ExportBpc;
